import { useState, useEffect, useCallback } from 'react';
import { useLogout } from 'react-admin';
import { Alert, Button, Snackbar } from '@mui/material';
import { setSessionExpiredCallback } from '../providers/cognito';

export const SessionExpiryWatcher = () => {
  const logout = useLogout();
  const [expired, setExpired] = useState(false);

  useEffect(() => {
    setSessionExpiredCallback(() => setExpired(true));
    return () => setSessionExpiredCallback(() => {});
  }, []);

  const handleSignIn = useCallback(() => {
    setExpired(false);
    logout();
  }, [logout]);

  return (
    <Snackbar open={expired} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
      <Alert
        severity="warning"
        action={
          <Button color="inherit" size="small" onClick={handleSignIn}>
            Sign in
          </Button>
        }
      >
        Your session expired (the server may have been updated). Sign in to continue.
      </Alert>
    </Snackbar>
  );
};
